<template>
  <!-- <el-breadcrumb separator="/">
    <el-breadcrumb-item :to="{ path: '/home' }"
      ><i class="el-icon-house"></i
    ></el-breadcrumb-item>
    <el-breadcrumb-item
      v-for="(item, index) in breadList"
      :key="index"
      :class="[$route.path === item.path ? 'isBreadcrumb' : '']"
      >{{ item.meta.title }}</el-breadcrumb-item
    >
  </el-breadcrumb> -->
  <div class="breadcrumb">
    <div class="t">
      <div
        class="item"
        :class="[$route.path === item.path ? 'isBreadcrumb' : '']"
        v-for="(item, index) in breadList"
        :key="index"
      >
        {{ item.meta.title }}<span>/</span>
      </div>
    </div>
    <div class="b">{{ $route.meta.title }}</div>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      breadList: [],
    };
  },
  // 监听属性
  watch: {
    // 监听路由
    $route(val) {
      // 调用获取路由数组方法
      this.getBreadList(val);
    },
  },
  mounted() {
    let val = this.$route;
    // 调用获取路由数组方法
    this.getBreadList(val);
  },
  // 自定义事件
  methods: {
    /**
     * @description 获取路由数组
     * @params val 路由参数
     * @author tw
     */
    getBreadList(val) {
      console.log(val)
      // 过滤路由matched对象
      if (val.matched) {
        // 字典详情
        if (val.path == "/dataDictionaryDetail") {
          this.breadList.push(val.matched[1]);
        } else {
          let matched = val.matched.filter(
            (item) => item.meta && item.meta.title
          );
          // 拿到过滤好的路由v-for遍历出来
          this.breadList = matched;
        }
      }
    },
  },
};
</script>
<!-- css样式 start-->
<style lang="scss" scoped>
.breadcrumb {
  display: flex;
  flex-direction: column;
  padding: 10px 0 0 25px;
  position: relative;
  .t {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .item {
      color: rgba(0, 0, 0, 0.45);
      span {
        margin: 0 5px;
      }
      &:last-child {
        span {
          display: none;
        }
      }
    }
    .isBreadcrumb {
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .b {
    font-size: 19px;
    color: rgba(0, 0, 0, 0.85);
  }
}
</style>
<!-- css样式 end-->
